export const BACKSPACE =  8;
export const SHIFT     = 16;
export const CTRL      = 17;
export const LEFT      = 37;
export const UP        = 38;
export const RIGHT     = 39;
export const DOWN      = 40;



/** WEBPACK FOOTER **
 ** ./src/keyboard-codes.es6.js
 **/